import t from "react";
import e from "prop-types";
import { Field as a } from "./index255.mjs";
import "./index13.mjs";
import { RADIO_STATES as r } from "./index161.mjs";
const n = (o) => {
  const {
    classes: s,
    disabled: d,
    id: p,
    label: m,
    name: b,
    onChange: c,
    readonly: u,
    required: f,
    state: i,
    title: g,
    tooltip: O,
    value: y,
    options: l,
    position: E
  } = o, { Label: h, Options: v, Option: T } = a;
  return /* @__PURE__ */ t.createElement(
    a,
    {
      id: p,
      value: y,
      onChange: c,
      classes: s,
      required: f,
      disabled: d,
      name: b,
      title: g,
      readonly: u,
      state: i,
      options: l
    },
    /* @__PURE__ */ t.createElement(h, { tooltip: O }, m),
    /* @__PURE__ */ t.createElement(v, { position: E }, l.map(({ option: R, label: q }, A) => /* @__PURE__ */ t.createElement(
      T,
      {
        ...o,
        key: A,
        option: R,
        label: q,
        state: i
      }
    )))
  );
};
n.propTypes = {
  value: e.string.isRequired,
  disabled: e.bool,
  state: e.oneOf(Object.values(r)),
  onChange: e.func,
  id: e.string,
  name: e.string,
  readonly: e.bool,
  required: e.bool,
  title: e.string,
  classes: e.string,
  children: e.node,
  tooltip: e.string,
  label: e.string,
  options: e.arrayOf(
    e.shape({
      label: e.string,
      option: e.string
    })
  ),
  position: e.oneOf(["horizontal", "vertical"])
};
n.defaultProps = {
  disabled: !1,
  // eslint-disable-next-line react/default-props-match-prop-types
  value: "",
  state: r.DEFAULT
};
export {
  n as RadioField,
  n as default
};
